import { render } from "./OtherResultIntermiadiate.vue?vue&type=template&id=1d5d8a56&scoped=true&ts=true"
import script from "./OtherResultIntermiadiate.vue?vue&type=script&lang=ts"
export * from "./OtherResultIntermiadiate.vue?vue&type=script&lang=ts"

import "./OtherResultIntermiadiate.vue?vue&type=style&index=0&id=1d5d8a56&lang=scss&scoped=true"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d5d8a56"]])

export default __exports__